// extracted by mini-css-extract-plugin
export default {"business_name":"businessName_business_name__NNggu","order_number":"businessName_order_number__166T6","confirmation":"businessName_confirmation__tw+gn"};